import { render, staticRenderFns } from "./ForumItem.vue?vue&type=template&id=dfd609ca&scoped=true"
import script from "./ForumItem.vue?vue&type=script&lang=ts"
export * from "./ForumItem.vue?vue&type=script&lang=ts"
import style0 from "./ForumItem.vue?vue&type=style&index=0&id=dfd609ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd609ca",
  null
  
)

export default component.exports